import { Navigate, useLocation } from 'react-router';

/** A bare record or section path on its way to its first tab. The query string goes with it, so a saved list URL (`/expenses?category=fuel`) keeps its filters. */
export function TabRedirect({ tab }: { tab: string }) {
  const { search } = useLocation();
  return <Navigate to={{ pathname: tab, search }} replace />;
}
